// صفحة مهام فرح - التصميم والمنطق موحّدين بـ components/EmployeeTasksPage.jsx
import React from "react";
import EmployeeTasksPage from "./components/EmployeeTasksPage";

const FarahTasks = () => (
  <EmployeeTasksPage employeeName="فرح" title="فرح" backPath="/farah" />
);

export default FarahTasks;
